
const data = [
    {
        id: "home",
        icon: "home",
        caption: "Home",
        to: "/dashboard",
        title: "Client Dashboard",
        description: " Client facing dashboard",
        display: [],
        permissions: ["CAN.LOGIN"],
        contains: {
            indent: 0,
            items: [
                {
                    id: "my_profile",
                    icon: "presentation",
                    caption: "My Profile",
                    to: "/dashboard/profile",
                    title: "My Profile",
                    description: "Biographical information about you",
                    display: ["Sidebar"],
                    permissions: ["CAN.LOGIN"],
                },
                {
                    id: "my_files",
                    icon: "save",
                    caption: "My Files",
                    to: "/dashboard/files",
                    title: "My Files",
                    description: "Files owned by or shared to you",
                    display: ["Sidebar"],
                    permissions: ["CAN.LOGIN"],
                },
                {
                    id: "my_surveys",
                    icon: "attachment",
                    caption: "My Surveys",
                    to: "/dashboard/surveys",
                    title: "My Surveys",
                    description: "Surveys sent to you",
                    display: ["Sidebar"],
                    permissions: ["CAN.LOGIN"],
                },
            ]
        }
    }
];

export default data;

